import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var generateStyle = function generateStyle(componentTheme) {
  var mq = "@media screen and ".concat(componentTheme.phoneBreakPoint);
  return {
    wrapper: _defineProperty({
      boxSizing: 'border-box',
      padding: componentTheme.wrapperPadding,
      transition: "".concat(componentTheme.wrapperTransitionDuration, " ease"),
      minHeight: '100%'
    }, mq, {
      padding: "".concat(componentTheme.phoneWrapperPadding, " 0")
    })
  };
};
export default generateStyle;